import { User } from '../../api/models/user.model';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

export const LoginIn = createAction(
    '[Auth] Login',
    props<{ email: string, password: string, rememberMe: boolean }>()
);

export const LogOut = createAction(
    '[Auth] Logout'
);

export const ExtendLogoutTimer = createAction('[Application] Extend the logout timer');

export const LoginSuccess = createAction(
    '[Auth] Login Success',
    props<{ user: User, rememberMe: boolean }>()
);

export const LogOutSuccess = createAction(
    '[Auth] Logout Success'
);

export const LoginFailure = createAction(
    '[Auth] Login Failed',
    props<{ error: any }>()
);

export const UserDetails = createAction('[Auth] User Details');

export const UserDetailsSuccess = createAction('[Auth] User Details Success', props<{ user: any }>());

export const authActionTypes = {
    LoginIn,
    LogOut,
    LoginSuccess,
    LogOutSuccess,
    LoginFailure,
    UserDetails,
    UserDetailsSuccess,
    ExtendLogoutTimer
};
